import { render, staticRenderFns } from "./BaseStepper.vue?vue&type=template&id=60cc868a"
import script from "./BaseStepper.vue?vue&type=script&lang=js"
export * from "./BaseStepper.vue?vue&type=script&lang=js"
import style0 from "./BaseStepper.vue?vue&type=style&index=0&id=60cc868a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports